<div class="container">
  <rt-avatar
    size="small-x"
    type="initials"
    [initials]="initials()"
    [context]="'admin'"
    margin-right-small-xx
  />
  <span white-space-pre-line> {{ memberName() }}</span>
</div>
